<div class="po-type" [class.is-loading]="isLoading">
  <label>{{ label }}</label>
  <select class="form-control" [(ngModel)]="value" (change)="onChange()">
    <option *ngFor="let type of clientPurchaseOrderTypes" [value]="type.id">
      {{ type.label }}
    </option>
  </select>
  <mat-spinner *ngIf="isLoading" [diameter]="16"></mat-spinner>
</div>
